import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', padding: '2rem', flexGrow: '1', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <h1>404 - Page Not Found</h1>
      <span>Oops! The page you're looking for does not exist.</span>
    </div>
  );
};

export default NotFoundPage;
